module.exports = __webpack_public_path__ + "img/bgimg.b015747d.png";